import { useRef } from "react";


const UserLiveShare = ({ }) => {
    const iframeRef = useRef(null);

    return (
        <>
           <div className="container">
            <div className='leaderboard-main'>
                    <div className='w-100 h-100'>
                        <iframe title="play" ref={iframeRef} className="w-100 h-100" src={"https://cdn.simulanis.io/unity/NSC/index.html"} width="100%" allowFullScreen />
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserLiveShare;
